export const hideOnScroll = function (el) {
    let prevScrollpos = window.pageYOffset;
    window.addEventListener("scroll", function () {
        if (window.innerWidth >= 1024) {
            let currentScrollPos = window.pageYOffset;
            if (
                prevScrollpos - 2 > currentScrollPos ||
                currentScrollPos <= 50
            ) {
                document.querySelector(".topbar").style.transform =
                    "translateY(0)";
            } else if (
                prevScrollpos <= currentScrollPos &&
                currentScrollPos > 100
            ) {
                document.querySelector(".topbar").style.transform =
                    "translateY(-100%)";
            }
            prevScrollpos = currentScrollPos;
        }
    });
};
